import React from "react"
import { useSelector } from "react-redux"
import { AriaLivePoliteness, selectAriaLive } from "../ariaLiveSlice"

interface AriaLiveRegionProps {
  id: string
  className?: string
}

export const AriaLiveRegion: React.FC<AriaLiveRegionProps> = ({
  id,
  className,
}) => {
  const { messages } = useSelector(selectAriaLive)
  const politeMessage = messages.find(
    (m) => m.id === id && m.politeness === AriaLivePoliteness.Polite,
  )
  const assertiveMessage = messages.find(
    (m) => m.id === id && m.politeness === AriaLivePoliteness.Assertive,
  )

  return (
    <div className="sr-only">
      <div aria-live="polite" aria-atomic="true" className={className}>
        {politeMessage?.message || ""}
      </div>
      <div aria-live="assertive" aria-atomic="true" className={className}>
        {assertiveMessage?.message || ""}
      </div>
    </div>
  )
}
